// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { Params } from '@feathersjs/feathers';
import type { ClientApplication } from '../../client';
import type {
  PendingFilm,
  PendingFilmData,
  PendingFilmPatch,
  PendingFilmQuery,
  PendingFilmService,
} from './pending-film.class';

export type { PendingFilm, PendingFilmData, PendingFilmPatch, PendingFilmQuery };

export type PendingFilmClientService = Pick<
  PendingFilmService<Params<PendingFilmQuery>>,
  (typeof pendingFilmMethods)[number]
>;

export const pendingFilmPath = 'api/pending-film';

export const pendingFilmMethods: Array<keyof PendingFilmService> = [
  'find',
  'get',
  'create',
  'patch',
  'remove',
  'approve',
  'reject',
];

export const pendingFilmClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(pendingFilmPath, connection.service(pendingFilmPath), {
    methods: pendingFilmMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [pendingFilmPath]: PendingFilmClientService;
  }
}
